import axios from 'axios';

const hostname = window.location.hostname;
let nimbusApiUrl = process.env.VUE_APP_NIMBUS_API_URL;

if (hostname === process.env.VUE_APP_EXTERNAL_URL) {
    nimbusApiUrl = process.env.VUE_APP_NIMBUS_EXTERNAL_API_URL;
}

const signUpClient = axios.create({
    baseURL: `${nimbusApiUrl}api/v1/`,
    headers: {
        'X-Emersion-Username': process.env.VUE_APP_X_EMERSION_USERNAME,
        'X-Emersion-Password': process.env.VUE_APP_X_EMERSION_PASSWORD,
    },
    // withCredentials: false,
});

signUpClient.interceptors.request.use(config => {
        const token = signUpClient.token;
        if (token) config.headers.Authorization = `Bearer ${token}`;

        return config;
    },
    error => {
        return Promise.reject(error);
    });

signUpClient.interceptors.response.use(
    response => {
        let data = response.data;
        return Promise.resolve(data);
    },
    error => {
        return Promise.reject(error);
    });

export default signUpClient;